module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.match) ? _c('div', [_c('div', {
    staticClass: "row columns text-centered"
  }, [_c('span', [_c('img', {
    staticClass: "small-league-icon",
    attrs: {
      "src": _vm.getLeagueIcon(_vm.match.home_report.team),
      "alt": "team"
    }
  }), _vm._v("\n            DungeonBowl du " + _vm._s(_vm._f("formatDate")(_vm.match.date)) + " :\n        ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row columns match_line"
  }, _vm._l((_vm.match.team_reports), function(tr) {
    return _c('div', {
      staticClass: "large-6 columns"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "large-2 columns"
    }, [_c('img', {
      staticClass: "team-icon-big",
      attrs: {
        "src": _vm.getRosterIcon(tr.team)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "large-7 columns text-left"
    }, [_c('div', {
      staticClass: "match-team-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'TeamDetail',
          params: {
            id: tr.team.id.toString()
          }
        }
      }
    }, [_vm._v(_vm._s(tr.team.name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "row columns match-stats"
    }, [_c('i', {
      staticClass: "fa fa-tag",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(tr.team.ref_roster))]), _vm._v(" "), _c('div', {
      staticClass: "row columns match-stats"
    }, [_c('i', {
      staticClass: "fa fa-user",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Coachés par " + _vm._s(tr.team.user))])]), _vm._v(" "), _c('div', {
      staticClass: "large-2 columns"
    }, [_c('div', {
      staticClass: "match-team-name"
    }, [_vm._v(_vm._s(_vm.getTDCount(tr)))])]), _vm._v(" "), _c('div', {
      staticClass: "large-1 columns"
    })]), _vm._v(" "), _c('br')])
  }), 0)]), _vm._v(" "), (_vm.actions) ? _c('div', {
    staticClass: "row columns"
  }, [(_vm.canBeContinued) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'mrDBStep2',
        params: {
          id: _vm.match.id.toString()
        }
      }
    }
  }, [_c('button', [_vm._v("Continuer la saisie du rapport")])]) : _vm._e(), _vm._v(" "), (_vm.canBeContinued) ? _c('button', {
    staticClass: "alert",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Supprimer")]) : _c('router-link', {
    attrs: {
      "to": {
        name: 'DBDetail',
        params: {
          id: _vm.match.id.toString()
        }
      }
    }
  }, [_c('button', {
    staticClass: "light-grey-button"
  }, [_vm._v("Details")])])], 1) : _vm._e()]) : _c('div', [_c('spinner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57dc9275"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/match-reports/mr-db-header.vue
// module id = 749
// module chunks = 0